import React from 'react';
import { Card } from "react-bootstrap";
import HierarchyField from '../common/HierarchyField';
import RadioField from '../common/RadioField';

/**
 * FacilityDetails Component - Handles facility information and availability options
 * 
 * @param {Object} props - Component props
 * @param {Object} props.values - Formik values object
 * @param {Function} props.setFieldValue - Formik setFieldValue function
 * @param {boolean} props.showSampleAvailability - Whether to show Sample Availability field (default: true)
 * @param {string} props.testType - Current test type for conditional logic
 * @param {string} props.className - Additional CSS classes for the container
 */
const FacilityDetails = ({
  values,
  setFieldValue,
  showSampleAvailability = true,
  testType = "",
  className = ""
}) => {

  // Test types that should NOT show Sample Availability field
  const TESTS_WITHOUT_SAMPLE_AVAILABILITY = [
    "Chest X Ray",
    "Cytopathology", 
    "Histopathology",
    "Gene Sequencing",
     "TST",
    "IGRA", 
    "Cy-Tb",
    "Other",
  ];

  // Determine if Sample Availability should be shown
  const shouldShowSampleAvailability = showSampleAvailability && !TESTS_WITHOUT_SAMPLE_AVAILABILITY.includes(testType);

  return (
    <Card className={`my-4 ${className}`}>
      <Card.Header className="bg-light p-3 mb-3">
        <h4 className="fw-bold mb-0 text-primary">Facility Details</h4>
      </Card.Header>
      <Card.Body className="mb-2">
        
        {/* Testing Facility Information Row */}
        <div className="row">
          {/* Testing Facility State - read-only, value pre-filled from user hierarchy */}
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">
                <span style={{ color: "red", fontSize: "20px" }}>*</span>
                Testing Facility State
              </label>
              <input
                type="text"
                className="form-control input-width"
                value={values.TestingFacilityState?.Value || ""}
                readOnly
                disabled
              />
            </div>
          </div>

          {/* Testing Facility District - read-only, value pre-filled from user hierarchy */}
          <div className="col-md-4">
            <div className="form-group">
              <label className="form-label">
                <span style={{ color: "red", fontSize: "20px" }}>*</span>
                Testing Facility District
              </label>
              <input
                type="text"
                className="form-control input-width"
                value={values.TestingFacilityDistrict?.Value || ""}
                readOnly
                disabled
              />
            </div>
          </div>

          {/* Testing Lab */}
          <div className="col-md-4">
            <HierarchyField
              name="TestingFacility.Value"
              label="Testing Lab:"
              required={true}
              placeholder="Select Testing Lab"
              apiMethod="getHierarchyFilters" // Different endpoint for labs
              parentId={values.TestingFacilityDistrict?.Key}
              setFieldValue={setFieldValue}
              values={values}
            />
          </div>
        </div>

        {/* Availability Options Row */}
        <div className="row">
          {/* Sample Availability - Conditional */}
          {shouldShowSampleAvailability && (
            <RadioField
              name="SampleAvailability"
              label="Sample Availability"
              required={true}
              colSize="col-md-4"
              // disabled={true}
            />
          )}

          {/* Result Availability - Always shown */}
          <RadioField
            name="ResultAvailability"
            label="Result Available"
            required={true}
            colSize="col-md-4"
            // disabled={true}
          />
        </div>

      </Card.Body>
    </Card>
  );
};

export default FacilityDetails;